import React from 'react'
import { Section } from "../../ui"
import LogoPNG from '../../../assets/images/logo.png'
import { Link } from 'react-router-dom'

import './getNFT.scss'

const GetYourNFTSection = () => {

    return (
        <Section variant="grey" id="nft_shop">
            <div className="getNFT-wrapper">
                <div className="content_container">
                    <h2 className="title">Get your unique NFT today...</h2>
                    <p className="description">Our NFT collections are project-themed artworks, which we publish to fund upcoming productions. When buying NFTs to support a project, you are simultaneously giving a community vote on which projects will be produced. If the project you supported is ultimately not chosen by the community, you are free to exchange your purchased NFTs into any other project-based NFTs anytime - as long as they are still available on our market place.</p>
                    <p className="description mt">All NFTs grant access to Hashrate Studio's airdrop program - and your share is not project-bound.</p>
                </div>
                <div className="img_container">
                    <img src={LogoPNG} />
                </div>
            </div>
        </Section>
    )
}

export default GetYourNFTSection
